import NProgressBarGlobalStyle from './NProgressBarGlobalStyle';

export * from './NProgressBarGlobalStyle';

export default NProgressBarGlobalStyle;
